const QUIZ_OPEN_EVENT = "quizOpen";
const QUIZ_CLOSE_EVENT = "quizClose";
const QUIZ_SECTION_LOADED_EVENT = "quizSectionLoaded";
const FINDATION_REQUEST_EVENT = "findationRequest";
const FINDATION_API_KEY =
  "c4f6b6cc4529b5a3116e8070cbefa6045dee971a811971d32e3eeb1b597c";
const FINDATION_MATCH = "findationMatch";
const FINDATION_ADD_MORE_SHADES = "findationAddMoreShades";

let mouseDown = false;
let startX, scrollLeft;

class QuizPopup extends HTMLElement {
  constructor() { 
    super();
    this.DEFAULT_DELAY = 400;

    // Navigation
    this.closeBtn = this.querySelector(".qz-close-btn"); // Close Quiz Button
    this.startQuizBtn = this.querySelector(".qz-start-btn"); // Button that starts the quiz (rendered on first quiz page)

    this.nav = this.querySelector(".qz-navigation"); // Nav container for prev & next buttons
    this.nextBtn = this.querySelector(".qz-next-btn"); // Next quiz page button
    this.prevBtn = this.querySelector(".qz-prev-btn"); // Previous quiz page button
    this.prevBtnResultPage = this.querySelector(".qz-prev-btn-results"); // Previous quiz page button
    this.skipStepBtn = this.querySelector(".qz-skip-findation-step-btn"); // Button to skip findation step
    this.addMoreShadesBtns = this.querySelectorAll(".qz-add-more-shades-btn")
    
    this.emailSkipBtn = this.querySelector(".qz-skip-email-step-btn");
    this.emailInput = this.querySelector(".qz-email-input");
    this.emailError = this.querySelector(".qz-email-error");

    this.resultsTitle = this.querySelector(".qz-phase-2-results-title")
    this.productGrid = this.querySelector(".qz-product-result-grid");
    this.articles = this.querySelector(".qz-result-articles");
    this.progressBar = this.querySelector(".qz-progress-bar");
    this.progressLoader = this.querySelector(".qz-progress-loader");
    this.shopShadeLinks = this.querySelectorAll(".qz-results-cta-wrap-btn");

    this.userEmail = "";
    this.getData();
    this.syncAnswer();

    this.getQuizData();
    this.getLSRecommendedProductsHTML();
    this.getLSRecommendationsMemo();
  }

  static get observedAttributes() {
    return ["view"];
  }

  attributeChangedCallback(attribute, previousValue, currentValue) {
    this.nextBtn.style.visibility =
      this.totalPages - currentValue === 0 || currentValue == 0
        ? "hidden"
        : "visible";
    // Back
    if (previousValue > currentValue) {
      this.store.answers = this.store.answers.slice(0, previousValue - 1);
      this.setData();
    }
    // Next
    else if (currentValue > previousValue) {
      this.showProductRecommendations();
    }

    this.checkCurrentPageInputs(currentValue);
  }

  /**
   * Retrieves and initializes the quiz data from local storage.
   *
   * This function attempts to parse the quiz data stored under the key "vieve-shade-quiz" in local storage. If the quiz data does not exist or is invalid (e.g., missing an 'id'), it initializes a new quiz object with a generated UUID as its 'id', an empty 'answers' object, and an empty 'results' object, then stores this new quiz object back into local storage under the same key. This ensures that subsequent operations have a valid quiz object to work with, even if no prior data exists.
   *

   * @returns {void} This function does not return a value; it modifies the `this.quiz` property of the class instance.
   */
  getQuizData() {
    this.quiz = JSON.parse(localStorage.getItem("vieve-shade-quiz"));
    if (!this.quiz?.id) {
      this.quiz = {
        id: crypto.randomUUID(),
        answers: {},
        results: {},
      };
      localStorage.setItem("vieve-shade-quiz", JSON.stringify(this.quiz));
    }
  }

  /**
   * Saves the current quiz data to local storage.
   *
   * Serializes the `this.quiz` object to a JSON string and stores it in local storage under the key "vieve-shade-quiz". This function ensures that the latest state of the quiz is persisted across sessions, allowing users to resume their quiz progress.
   *

   * @returns {void} This function does not return a value; it modifies local storage directly.
   */
  setQuizData() {
    localStorage.setItem("vieve-shade-quiz", JSON.stringify(this.quiz));
  }

  getData() {
    this.store = JSON.parse(localStorage.getItem("vieve-quiz"));
    if (!this.store?.id) {
      this.store = {
        id: crypto.randomUUID(),
        answers: [],
      };
      localStorage.setItem("vieve-quiz", JSON.stringify(this.store));
    }
  }

  setData() {
    localStorage.setItem("vieve-quiz", JSON.stringify(this.store));
  }

  /**
   * Retrieves the current quiz page index from local storage and validates it.
   * Ensures the stored page index is a number and within the valid range of available pages.
   * If the stored page index is invalid or not set, it resets the stored page index to 0.
   *
   * @returns {number} The validated page index from local storage, or 0 if invalid or not set.
   */
  getLSPage() {
    this.lsPage = JSON.parse(localStorage.getItem("vieve-quiz-page"));
    if (
      !this.lsPage ||
      typeof this.lsPage !== "number" ||
      this.pages.length - 1 < this.lsPage
    ) {
      this.lsPage = 0;
      localStorage.setItem("vieve-quiz-page", JSON.stringify(this.lsPage));
    }

    return this.lsPage;
  }

  getLSRecommendedProductsHTML() {
    this.recommendedProductsHTML = JSON.parse(
      localStorage.getItem("vieve-quiz-recommended-products")
    );
    if (
      !this.recommendedProductsHTML ||
      typeof this.recommendedProductsHTML !== "string"
    ) {
      this.recommendedProductsHTML = "";
      localStorage.setItem(
        "vieve-recommended-products",
        JSON.stringify(this.recommendedProductsHTML)
      );
    }

    this.articlesHTML = JSON.parse(
      localStorage.getItem("vieve-quiz-recommended-articles")
    );
    if (!this.articlesHTML || typeof this.articlesHTML !== "string") {
      this.articlesHTML = "";
      localStorage.setItem(
        "vieve-quiz-recommended-articles",
        JSON.stringify(this.articlesHTML)
      );
    }
  }

  setLSRecommendedProductsHTML() {
    localStorage.setItem(
      "vieve-quiz-recommended-products",
      JSON.stringify(this.recommendedProductsHTML)
    );

    localStorage.setItem(
      "vieve-quiz-recommended-articles",
      JSON.stringify(this.articlesHTML)
    );
  }

  getLSRecommendationsMemo() {
    this.recommendationsMemo = JSON.parse(
      localStorage.getItem("vieve-quiz-recommended-memo")
    );

    if (!this.recommendationsMemo) {
      this.recommendationsMemo = Object.values(this.quiz.answers).flatMap(
        (answer) => {
          if (answer.answer) {
            return answer.answer;
          } else if (answer.answers) {
            return answer.answers;
          }
        }
      );
    }
  }

  setLSRecommendationsMemo() {
    localStorage.setItem(
      "vieve-quiz-recommended-memo",
      JSON.stringify(this.recommendationsMemo)
    );
  }

  /**
   * Updates the current quiz page index in local storage.
   * Ensures the page index is a valid number within the range of available pages. If an invalid index is provided,
   * resets the stored page index to 0 to prevent the application from referencing a non-existent page.
   *
   * @param {number} pageIndex - The index of the current page to be stored. This should be a number representing the quiz page the user is currently on.
   * @returns {void} This function does not return a value.
   */
  setLSPage(pageIndex) {
    if (
      typeof pageIndex === "number" &&
      pageIndex >= 0 &&
      pageIndex < this.pages.length
    ) {
      this.lsPage = pageIndex;
      localStorage.setItem("vieve-quiz-page", JSON.stringify(pageIndex));
    } else {
      console.error(
        "Invalid page index provided to setLSPage. Page index must be a number within the valid range of pages."
      );
    }
  }

  /**
   * Highlights matching product cards based on the user's quiz answers and activates the corresponding badge.
   *
   * This function iterates through all product cards within the quiz popup to find matches based on the user's quiz answers stored in `this.store.answers`. If a match is found, it reveals the product's badge by removing the 'hidden' class and adding an 'active' class to make it visible. This is used to visually indicate to the user which products match their quiz results. The function also sets the active result based on the index of the matched product card.
   *

   * @returns {void} This function does not return a value; it modifies the DOM by toggling classes on elements to indicate product matches.
   */
  showProductRecommendations() {
    const productCards = this.querySelectorAll("[data-product-id]");
    if (!productCards.length) return;

    productCards.forEach((productElement, i) => {
      const vieveBadge = productElement.querySelector(".qz-results-vieve");
      const id = productElement.dataset.productShade;
      const productMatch = this.store.answers.find((answer) =>
        answer.products.includes(id)
      );
      vieveBadge.classList.toggle("hidden", !productMatch);
      if (productMatch) {
        vieveBadge.classList.add("active");
        this.setActiveResult(i);
      } else {
        vieveBadge.classList.remove("active");
      }
      console.log('ffff',this.quiz.results.customer_chosen);
      this.shopShadeLinks.forEach((link) => {
        if (this.quiz?.results?.customer_chosen) {
          if (this.quiz.results.customer_chosen === productElement.dataset.productId) {
            const skinTone = link.querySelector(".qz-skin-tone-text");
            const shade = link.querySelector(".qz-skin-shade-text");
            shade.textContent = `${productElement.dataset.productShade}`;
            skinTone.textContent = `${productElement.dataset.productSkinTone}`;
            link.href = `/products/${productElement.dataset.productHandle}`
          }
        } else {
          if (this.quiz.results.vieve === productElement.dataset.productId) {
            const skinTone = link.querySelector(".qz-skin-tone-text");
            const shade = link.querySelector(".qz-skin-shade-text");
            shade.textContent = `${productElement.dataset.productShade}`;
            skinTone.textContent = `${productElement.dataset.productSkinTone}`;
            link.href = `/products/${productElement.dataset.productHandle}`;
          }
        }
      });
    });
  }

  /**
   * Highlights matching product cards based on the Findation product title and shade, and activates the corresponding badge.
   *
   * This function searches through all product cards within the quiz popup to find matches based on the provided Findation product title and shade. If a match is found, it reveals any hidden legend items related to Findation and activates the Findation badge on the matching product card by removing the 'hidden' class and adding an 'active' class to make it visible. This is used to visually indicate to the user which products match their Findation result.
   *

   * @param {string} findationProductTitle - The title of the product as returned by the Findation API.
   * @param {string} findationShade - The shade of the product as returned by the Findation API.
   * @param {number} id - The unique identifier for the Findation match. This parameter is currently not used within the function but is included for potential future use or extension.
   *
   * @example
   * // Assuming findationProductTitle and findationShade are obtained from a Findation API response or similar source
   * showFindationMatch("Modern Radiance Concealer", "Light 1", "12345");
   */
  showFindationMatch(findationProductTitle, findationShade, id) {
    const productCards = this.querySelectorAll("[data-product-id]");
    if (!productCards.length) return;

    if (!findationShade) {
      productCards.forEach((productElement) => {
        const findationBadge = productElement.querySelector(
          ".qz-results-findation"
        );
        this.querySelectorAll(".qz-legend-item.findation-legend").forEach(
          (el) => el.classList.add("hidden")
        );
        findationBadge.classList.add("hidden");
        findationBadge.classList.remove("active");
      });
      return;
    }

    productCards.forEach((productElement) => {
      const product = productElement.dataset.productTitle;
      const shade = productElement.dataset.productShade;
      const findationBadge = productElement.querySelector(
        ".qz-results-findation"
      );

      if (shade.toLowerCase() == findationShade.toLocaleLowerCase()) {
        if (this.quiz?.answers?.Findation) {
          const existingFindationAnswer = { ...this.quiz.answers.Findation};
          const existingProducts = existingFindationAnswer.products
          if (existingProducts.includes(id)) {
            this.quiz.answers.Findation = {
              ...existingFindationAnswer,
              timestamp: new Date().toISOString(),
            };
          } else {
            this.quiz.answers.Findation = {
              answer: `${existingFindationAnswer.answer},${findationProductTitle}`,
              products: [...existingFindationAnswer.products, id],
              shade: `${existingFindationAnswer.shade},${findationShade}`,
              timestamp: new Date().toISOString(),
            };
          }
        } else {
          this.quiz["answers"]["Findation"] = {
            answer: findationProductTitle,
            products: [id],
            shade: findationShade,
            timestamp: new Date().toISOString(),
          };
        }

        if (this.quiz?.results?.findation) {
          if (!this.quiz["results"]["findation"].split(",").includes(productElement.dataset.productId)) {
            this.quiz["results"]["findation"] = `${this.quiz.results.findation},${productElement.dataset.productId}`;
          }
        } else {
          this.quiz["results"]["findation"] = productElement.dataset.productId;
        }

        this.setQuizData();

        this.querySelectorAll(".qz-legend-item.findation-legend").forEach(
          (el) => el.classList.remove("hidden")
        );
        findationBadge.classList.remove("hidden");
        findationBadge.classList.add("active");
      }
    });
  }

  /**
   * Highlights product cards matching previous Findation results.
   *
   * Searches for product cards that match the stored Findation product title and shade, revealing and activating their badges.
   *

   * @returns {void} Modifies the DOM to indicate matches.
   */
  showPreviousFindationMatch() {
    const productCards = this.querySelectorAll("[data-product-id]");
    if (!productCards.length || !this.quiz?.answers?.Findation) return;

    const findationShade = this.quiz["answers"]["Findation"]?.shade;

    if (!findationShade) return;

    // console.log("showPreviousFindationMatch");
    // console.log(findationShade);

    const findationShades = findationShade.split(",").map(shade => shade.toLocaleLowerCase());

    productCards.forEach((productElement) => {
      const shade = productElement.dataset.productShade;
      const findationBadge = productElement.querySelector(
        ".qz-results-findation"
      );
      if (findationShades.includes(shade.toLocaleLowerCase())) {
        this.querySelectorAll(".qz-legend-item.findation-legend").forEach(
          (el) => el.classList.remove("hidden")
        );
        findationBadge.classList.remove("hidden");
        findationBadge.classList.add("active");
      }
    });
  }

  selectMoreShades() {
    let findationPageIdx = null;
    this.pages.forEach((page, idx) => {
      if (page.classList.contains("qz-findation-page")) {
        findationPageIdx = idx;
      }
    });
    if (findationPageIdx !== null) {
      document.dispatchEvent(new CustomEvent(FINDATION_ADD_MORE_SHADES))

      Array
        .from({length: this.state.currentPageIndex - findationPageIdx})
        .fill(() => null)
        .forEach(i => {
          this.prevPage();
        });
    }
  }

  collectData() {
    const timestamp = new Date().toISOString();
    const page = this.state.currentPageIndex;

    let hasPrimaryInputChecked = false;
    this.primaryInputs.forEach((input) => {
      if (input.checked) {
        this.quiz["answers"]["Shade Range"] = {
          answer: input.value,
          products: input.dataset.productShade || "",
          timestamp: timestamp,
        };
        hasPrimaryInputChecked = true;
      }
    });
    if (!hasPrimaryInputChecked) {
      this.quiz["answers"]["Shade Range"] = {
        answer: "",
        products: [],
        timestamp: timestamp,
      };
      this.quiz["answers"]["Skin Tone"] = {
        answer: "",
        products: [],
        timestamp: timestamp,
      };
      // this.quiz["results"]["vieve"] = input.dataset.productShade || "";
    }

    let hasSecondaryInputChecked = false;
    this.secondaryInputs.forEach((input) => {
      if (input.checked) {
        this.quiz["answers"]["Skin Tone"] = {
          answer: input.value,
          products: input.dataset.productShade || "",
          timestamp: timestamp,
        };

        this.quiz["results"]["vieve"] = input.dataset.productShade || "";
        hasSecondaryInputChecked = true;
      }
    });
    if (!hasPrimaryInputChecked) {
      this.quiz["answers"]["Skin Tone"] = {
        answer: "",
        products: [],
        timestamp: timestamp,
      };
      // this.quiz["results"]["vieve"] = input.dataset.productShade || "";
    }

    const values = [
      ...this.querySelectorAll(`.qz-page-${page} .js-data`),
    ].reduce(
      (obj, input) => {
        if (!input?.value) return obj;
        if (input.type === "radio" && !input.dataset.phaseTwo) {
          if (input.checked) {
            obj = {
              answers: [...obj.answers, input.value],
              products: [
                ...obj.products,
                ...([input.dataset.productShade || ""] || []),
              ],
            };
          }
        } else {
          obj = {
            answers: [...obj.answers, input.value],
            products: [],
          };
        }
        return obj;
      },
      {
        answers: [],
        products: [],
      }
    );

    if (values.answers.length) {
      this.store.answers[page - 1] = {
        answer: values.answers.join(";"),
        products: values.products,
        timestamp: timestamp,
      };
    }

    this.store.lastChange = timestamp;
    this.setData();
    this.setQuizData();
  }

  connectedCallback() {
    document.addEventListener(FINDATION_MATCH, (event) => {
    // console.log('event: ', event);
      try {
        const { title, shade, id } = event.detail;
        this.showFindationMatch(title, shade, id);
      } catch (error) {
        // console.log(error);
      }
    });

    this.totalPages = +this.dataset.pages;
    this.state = null;

    this.overlay = this.querySelector(".qz-overlay"); // Overlay
    this.section = this.querySelector(".qz-section"); // Quiz Section Container
    this.pages = this.querySelectorAll(".qz-page"); // NodeList of all quiz pages
    this.resultscarousel = document.querySelector("div.qz-results-inner");

    this.carousel = {};
    this.carousel.drag = {};

    this.carousel.drag.startDragging = (e) => {
      mouseDown = true;
      this.resultscarousel.style['scroll-snap-type'] = 'none';
      this.resultscarousel.style['user-select'] = 'none';
      startX = e.pageX - this.resultscarousel.offsetLeft;
      scrollLeft = this.resultscarousel.scrollLeft;
    }
    
    this.carousel.drag.stopDragging = (e) => {
      mouseDown = false;
      setTimeout(() => {
        //this.resultscarousel.style['scroll-snap-type'] = 'x';
        this.resultscarousel.style['user-select'] = 'auto';
      }, 300);
      
    }
    
    this.carousel.drag.move = (e) => {
      e.preventDefault();
      if(!mouseDown) { return; }
      const x = e.pageX - this.resultscarousel.offsetLeft;
      const scroll = x - startX;
      this.resultscarousel.scrollLeft = scrollLeft - scroll;
    }

    // Add the event listeners
    this.resultscarousel.addEventListener('mousemove', this.carousel.drag.move, false);
    this.resultscarousel.addEventListener('mousedown', this.carousel.drag.startDragging, false);
    this.resultscarousel.addEventListener('mouseup', this.carousel.drag.stopDragging, false);
    this.resultscarousel.addEventListener('mouseleave', this.carousel.drag.stopDragging, false);
    

    // Attach event listeners to all inputs to update localStorage on change
    this.pages.forEach((page, index) => {
      page.querySelectorAll("input").forEach((input) => { 
        if (input.type === "email") return;

        input.addEventListener("change", () => {
          this.handleInputChange(input.getAttribute("id"), index);
        });
      });
    });

    this.overlay.addEventListener("click", () =>
      document.dispatchEvent(new CustomEvent(QUIZ_CLOSE_EVENT))
    );

    this.closeBtn.addEventListener("click", () =>
      document.dispatchEvent(new CustomEvent(QUIZ_CLOSE_EVENT))
    );

    this.startQuizBtn.addEventListener("click", this.nextPage.bind(this));
    this.nextBtn.addEventListener("click", this.nextPage.bind(this));
    this.prevBtn.addEventListener("click", this.prevPage.bind(this));
    this.addMoreShadesBtns.forEach(btn => {
      btn.addEventListener("click", this.selectMoreShades.bind(this));
    });

    if (this.prevBtnResultPage) {
      this.prevBtnResultPage.addEventListener("click", () => this.prevPage());
    }
    
    // Skip step button in only present if there is a findation page block on the quiz.
    if (this.skipStepBtn) {
      // Button is present. Add event listener to go to next page
      this.skipStepBtn.addEventListener("click", this.nextPage.bind(this));
    }
    if (this.emailSkipBtn) {
      this.emailSkipBtn.addEventListener("click", this.nextPage.bind(this));
    }

    // The selected input on first page (referred to as primary) determines which
    // inputs will be rendered on second page. A change in primary input selection must
    // trigger a change in secondary inputs.
    this.primaryInputs = this.querySelectorAll(".qz-primary-input");
    this.secondaryInputs = this.querySelectorAll(".qz-secondary-input");
    this.primaryInputs.forEach((input) => {
      input.addEventListener("change", () => {
        this.secondaryInputs.forEach((secondaryInput) => {
          secondaryInput.checked = false;
        });
      });
    });

    this.initializePhaseTwo();
    this.showPreviousFindationMatch();

    document.addEventListener(QUIZ_OPEN_EVENT, () => {
      this.revealQuiz();
    });

    document.addEventListener(QUIZ_CLOSE_EVENT, () => {
      this.hideQuiz();
    });

    this.checkHash();

    this.carousel = this.querySelector(".qz-results");
    this.productCards = this.querySelectorAll(".qz-results-product");

    this.productCards?.forEach((prod, i) => {
      if (
        (this.quiz?.results?.customer_chosen &&
          this.quiz.results.customer_chosen === prod.dataset.productId) ||
        (this.quiz?.results?.vieve &&
          !this.quiz?.results?.customer_chosen &&
          this.quiz.results.vieve === prod.dataset.productShade)
      ) {
        this.productCards.forEach((prod, j) => {
          prod.classList.toggle("active", i === j);
          const vieveBadge = prod.querySelector(".qz-results-vieve");
          vieveBadge.classList.remove("active");
        });
        this.resultscarousel.scrollTo({
          left: prod.offsetLeft - prod.offsetWidth,
          behavior: "smooth",
        });
        this.shopShadeLinks.forEach((link) => {
          const skinTone = link.querySelector(".qz-skin-tone-text");
          const shade = link.querySelector(".qz-skin-shade-text");
          shade.textContent = `${prod.dataset.productShade}`;
          skinTone.textContent = `${prod.dataset.productSkinTone}`;
          link.href = `/products/${prod.dataset.productHandle}`;
        });
      }

      prod.addEventListener("click", () => {
        this.quiz["results"]["customer_chosen"] = prod.dataset.productId;
        this.quiz["results"]["selected_shade"] = prod.dataset.productShade;
        this.setQuizData();
        this.productCards.forEach((prod, j) => {
          prod.classList.toggle("active", i === j);
          const vieveBadge = prod.querySelector(".qz-results-vieve");
          vieveBadge.classList.remove("active");
        });
        this.resultscarousel.scrollTo({
          left: prod.offsetLeft - prod.offsetWidth,
          behavior: "smooth",
        });
        this.shopShadeLinks.forEach((link) => {
          const skinTone = link.querySelector(".qz-skin-tone-text");
          const shade = link.querySelector(".qz-skin-shade-text");
          shade.textContent = `${prod.dataset.productShade}`
          skinTone.textContent = `${prod.dataset.productSkinTone}`;
          link.href = `/products/${prod.dataset.productHandle}`;
        });
      });
    });

    this.initializeProductRecommendations();
  }

  /**
   * Scrolls the view to a specific product card within the quiz results, highlighting it as the active result based on the provided index.
   *
   * This function checks if the product cards are available and then attempts to scroll the specified product card into view. If the exact index is not available, it tries to scroll to the previous card. It uses the `scrollIntoView` method to smoothly bring the product card into view, with an option to align it in the center of the container if specified.
   *

   * @param {number} index - The index of the product card to scroll to and highlight as active. This should be a number representing the position of the product card within the `this.productCards` NodeList.
   *
   * @example
   * setActiveResult(2); // Scrolls to the third product card and aligns it in the center of the container.
   */
  setActiveResult(index) {
    if (!this.productCards) return;

    if (this.productCards[index]) {
      this.productCards[index].scrollIntoView({ inline: "center" });
    } else if (this.productCards[index - 1]) {
      this.productCards[index - 1].scrollIntoView();
    } else {
      return;
    }
  }

  /**
   * Checks the URL hash for a specific value and triggers a custom event if the condition is met.
   *
   * This function listens for changes in the URL hash and dispatches a custom event when the hash matches "#skinquiz". It initially checks the current hash upon invocation and sets up an event listener to react to future changes in the URL hash.
   * When the URL hash equals `#skinquiz`, it dispatches a custom event named `quizOpen`, with it's name being saved in a constant `QUIZ_OPEN_EVENT`, to signal that the quiz should be opened. This mechanism allows the quiz to be opened via URL manipulation, enabling deep linking directly to the quiz section of the page.
   *
   * @listens window#hashchange - Listens for changes to the window's hash property to trigger quiz opening.
   * @fires QUIZ_OPEN_EVENT - Dispatches this event when the URL hash matches "#skinquiz".
   */
  checkHash() {
    if (window.location.hash === "#skinquiz")
      document.dispatchEvent(new CustomEvent(QUIZ_OPEN_EVENT));

    window.addEventListener("hashchange", () => {
      if (window.location.hash === "#skinquiz")
        document.dispatchEvent(new CustomEvent(QUIZ_OPEN_EVENT));
    });
  }

  revealQuiz() {
    this.overlay.style.visibility = "visible";
    this.overlay.classList.add("active");

    const index = this.getLSPage();

    if (index == 0) {
      this.section.classList.add("active", "first-page");
    } else {
      this.section.classList.remove("first-page");
      this.section.classList.add("active");
    }

    // There is no existing current page.
    // Reveal the first page of the quiz.
    this.state = {
      currentPage: this.pages[index],
      currentPageIndex: index,
    };

    this.setAttribute("view", this.state.currentPageIndex);

    const currentPage = this.state.currentPage;
    const currentPageIndex = this.state.currentPageIndex;

    currentPage.style.visibility = "visible";
    currentPage.classList.add("active");

    this.setProgressBar(currentPageIndex);
    this.setNavControls(currentPageIndex);
    this.checkCurrentPageInputs(currentPageIndex);

    // Disable scroll when quiz is opened
    document.body.style.overflow = "hidden";

    this.showCorrectOptions();

    // Add quiz open action to analytics array
    const pageEvents = JSON.parse(localStorage.getItem("qI-page-events")) ?? [];
    pageEvents.push({
      name: "quiz-action",
      data: {
        action: "Opened",
        "quiz-info": JSON.stringify(this.store),
      },
      timestamp: new Date().toISOString(),
    });

    localStorage.setItem("qI-page-events", JSON.stringify(pageEvents));
  }

  hideQuiz() {
    const currentPageIndex = this.state.currentPageIndex;
    this.pages.forEach((page, i) => {
      if (i !== currentPageIndex) {
        page.classList.remove("active");
        page.style.visibility = "hidden";
      }
    });

    const currentPage = this.state.currentPage;
    currentPage.classList.remove("active");
    this.overlay.classList.remove("active");

    this.setVisibility(currentPage, false, this.DEFAULT_DELAY);
    this.setVisibility(this.overlay, false, this.DEFAULT_DELAY);

    this.setProgressBar(currentPageIndex);
    this.setNavControls(currentPageIndex);

    this.section.classList.add("first-page");
    this.section.classList.remove("active");

    // Enable scroll when quiz is closed
    document.body.style.overflow = "auto";

    // Add quiz open action to analytics array
    const pageEvents = JSON.parse(localStorage.getItem("qI-page-events")) ?? [];
    const storedQuiz = JSON.parse(localStorage.getItem("vieve-quiz")) ?? {};
    pageEvents.push({
      name: "quiz-action",
      data: {
        action: "Closed",
        "quiz-info": JSON.stringify(storedQuiz),
      },
      timestamp: new Date().toISOString(),
    });

    localStorage.setItem("qI-page-events", JSON.stringify(pageEvents));
  }

  nextPage() {
    const pagesLength = this.pages.length;
    const currentPageIndex = this.state.currentPageIndex;

    if (currentPageIndex > pagesLength - 2) return;

    if (currentPageIndex === pagesLength - 2) {
      // console.log("RESULTS PAGE REACHED");
      this.getProductRecommendations();
    }

    if (this.pages[currentPageIndex]?.classList?.contains("qz-email-page")) {
      this.handleSubscribe();
    }

    // Transition UI to next page
    const nextPage = this.pages[currentPageIndex + 1];
    const currentPage = this.state.currentPage;

    nextPage.style.visibility = "visible";
    currentPage.classList.remove("active");
    nextPage.classList.add("active");

    if (currentPageIndex === 0) {
      this.section.classList.remove("first-page");
    }

    this.setVisibility(currentPage, false, this.DEFAULT_DELAY);

    this.setProgressBar(currentPageIndex + 1);
    this.setNavControls(currentPageIndex + 1);

    // Update state
    this.state = {
      currentPage: nextPage,
      currentPageIndex: currentPageIndex + 1,
    };
    this.setLSPage(this.state.currentPageIndex);
    this.setAttribute("view", this.state.currentPageIndex);
  }

  prevPage() {
    const currentPageIndex = this.state.currentPageIndex;
    if (currentPageIndex === 0) return;

    // Transition UI to previous page
    const prevPage = this.pages[currentPageIndex - 1];
    const currentPage = this.state.currentPage;

    prevPage.style.visibility = "visible";
    currentPage.classList.remove("active");
    prevPage.classList.add("active");

    if (currentPageIndex === 1) {
      this.section.classList.add("first-page");
    }

    this.setVisibility(currentPage, false, this.DEFAULT_DELAY);
    this.setProgressBar(currentPageIndex - 1);
    this.setNavControls(currentPageIndex - 1);

    // Update state
    this.state = {
      currentPage: prevPage,
      currentPageIndex: currentPageIndex - 1,
    };
    this.setLSPage(this.state.currentPageIndex);
    this.setAttribute("view", this.state.currentPageIndex);
  }

  initializePhaseTwo() {
    this.phaseTwoFieldsetValues = this.querySelectorAll("[data-column]");
    const columns = Array.from(this.phaseTwoFieldsetValues).map((fieldset) => {
      const column = fieldset.dataset.column;

      if (!this.quiz["answers"][column]) {
        this.quiz["answers"][column] = {
          answers: [],
        };
      }

      const radioInputs = fieldset.querySelectorAll('input[type="radio"]');
      if (radioInputs && radioInputs.length !== 0) {
        radioInputs.forEach((input) => {
          if (this.quiz["answers"][column]?.answers?.includes(input.value)) {
            input.checked = true;
          }
          input.addEventListener("change", () => {
            if (input.checked) {
              this.quiz["answers"][column] = {
                answers: [input.value],
                timestamp: new Date().toISOString(),
              };
            }
            this.setQuizData();
          });
        });
        return column;
      } else {
        const checkBoxInputs = fieldset.querySelectorAll(
          'input[type="checkbox"]'
        );
        if (checkBoxInputs) {
          this.querySelector(
            `.qz-select-all-applicable.${column}`
          )?.classList?.remove("hidden");

          checkBoxInputs.forEach((input) => {
            if (this.quiz["answers"][column]?.answers?.includes(input.value)) {
              input.checked = true;
            }
            input.addEventListener("change", () => {
              if (input.checked) {
                this.quiz["answers"][column]?.answers.push(input.value);
                this.quiz["answers"][column].timestamp =
                  new Date().toISOString();
              } else {
                this.quiz["answers"][column]["answers"] = this.quiz["answers"][
                  column
                ]?.answers.filter((value) => value !== input.value);
                this.quiz["answers"][column].timestamp =
                  new Date().toISOString();
              }

              const isAnyInputChecked = Array.from(checkBoxInputs).some(
                (input) => input.checked
              );
              if (!isAnyInputChecked)
                this.nextBtn.setAttribute("disabled", true);

              this.setQuizData();
            });
          });
        }
        return column;
      }
    });
    this.setQuizData();
  }

  /**
   * Adjusts the visibility and position of the progress bar and loader based on the current page and total pages.
   *
   * This function calculates the progress percentage and applies it to the progress loader's **transform** property instead of width.
   * It also controls the visibility of the progress bar and loader based on the current page index and the total number of pages.
   *
   * @param {number} currentPageIndex - The index of the current page, starting from 0.
   *
   * @returns {void} This function does not return any value.
   */
  setProgressBar(currentPageIndex) {
    if (currentPageIndex === 0) {
      this.progressBar.closest(".qz-progress-container").style.visibility =
        "hidden";
      this.progressLoader.style.transform = "translateX(0%)";
    } else {
      if (this.totalPages <= 1) return;
      this.progressBar.closest(".qz-progress-container").style.visibility =
        "visible";
      const progress = (currentPageIndex / this.totalPages) * 100;
      this.progressLoader.style.transform = `translateX(${progress}%)`;
    }
  }

  /**
   * Updates the navigation controls based on the current page index.
   *
   * This method adjusts the visibility and disabled states of the start quiz button, navigation container,
   * and the previous/next buttons depending on the current page index. It ensures that on the first page,
   * only the start quiz button is visible and enabled, while the navigation controls (previous/next buttons)
   * are hidden and disabled. On subsequent pages, the navigation controls become visible and enabled,
   * and the start quiz button becomes hidden and disabled.
   *
   * @param {number} pageIndex - The zero-based index of the current page within the quiz. A value of `0` indicates the first page.
   */
  setNavControls(pageIndex) {
    if (pageIndex === 0) {
      this.startQuizBtn.style.visibility = "visible";
      this.nav.style.visibility = "hidden";
      this.startQuizBtn.removeAttribute("disabled");
      this.prevBtn.setAttribute("disabled", true);
      this.prevBtnResultPage.setAttribute("disabled", true);
      this.nextBtn.setAttribute("disabled", true);
    } else if (pageIndex > 0 && pageIndex < this.totalPages) {
      this.startQuizBtn.style.visibility = "hidden";
      this.nav.style.visibility = "visible";
      this.nextBtn.style.visibility = "visible";
      this.startQuizBtn.setAttribute("disabled", true);
      this.prevBtn.removeAttribute("disabled");
      this.prevBtnResultPage.setAttribute("disabled", true);
      this.nextBtn.removeAttribute("disabled");
    } else {
      this.nav.style.visibility = "hidden";
      this.prevBtnResultPage.removeAttribute("disabled");
    }

    // Check if skipStepBtn is present.
    // Remove disabled attribute only if current page has class ".qz-findation-page" 
    if (
      this.skipStepBtn &&
      this.pages[pageIndex] &&
      this.pages[pageIndex]?.classList
    ) {
      this.pages[pageIndex].classList.contains("qz-findation-page")
        ? this.skipStepBtn.removeAttribute("disabled")
        : this.skipStepBtn.setAttribute("disabled", true);
    }
    if (
      this.emailSkipBtn &&
      this.pages[pageIndex] &&
      this.pages[pageIndex]?.classList
    ) {
      this.pages[pageIndex].classList.contains("qz-email-page")
        ? this.emailSkipBtn.removeAttribute("disabled")
        : this.emailSkipBtn.setAttribute("disabled", true);
    }
  }

  /**
   * Checks if there are any inputs on the current page of type radio.
   * If there are any radio or checkbox inputs and none of them are checked, then next button is disabled.
   *
   * @param {number} pageIndex - The zero-based index of the current page within the quiz. A value of `0` indicates the first page.
   *
   * @returns {void} This function does not return any value.
   */
  checkCurrentPageInputs(pageIndex) {
    const radioInputs = this.querySelectorAll(
      `.qz-page-${pageIndex} input[type="radio"]`
    );
    if (radioInputs.length > 0) {
      const isAnyInputChecked = Array.from(radioInputs).some(
        (input) => input.checked
      );
      if (!isAnyInputChecked) {
        this.nextBtn.setAttribute("disabled", true);
      }
    }

    const checkBoxInputs = this.querySelectorAll(
      `.qz-page-${pageIndex} input[type="checkbox"]`
    );
    if (checkBoxInputs.length > 0) {
      const filteredCheckboxes = Array.from(checkBoxInputs).filter(
        (input) => !input.classList.contains("qz-email-checkbox")
      );
      if (filteredCheckboxes.length > 0) {
        const isAnyInputChecked = filteredCheckboxes.some(
          (input) => input.checked
        );
        if (!isAnyInputChecked) {
          this.nextBtn.setAttribute("disabled", true);
        }
      }
    }
  }

  /**
   * Sets the visibility of an element based on the provided conditions.
   *
   * This function allows for setting the visibility of an element either immediately or after a specified delay.
   * It toggles the `style.visibility` property of the target element between `"visible"` and `"hidden"`.
   * Additionally, it handles asynchronous operations through Promises for delayed visibility changes.
   *
   * @param {HTMLElement} el - The DOM element whose visibility needs to be changed.
   * @param {boolean} visible - A boolean indicating whether the element should be visible (`true`) or hidden (`false`).
   * @param {number} [delay=0] - An optional number specifying the delay in milliseconds before changing the visibility. Defaults to `0` for immediate change.
   * @param {function} [callback] - An optional callback function to execute after the visibility change is applied.
   * @returns {Promise<void>} Returns a Promise that resolves once the visibility change operation is complete. Resolves to `undefined`.
   */
  async setVisibility(el, visible, delay = 0, callback = undefined) {
    if (delay) {
      await new Promise((resolve) => setTimeout(resolve, delay));
      el.style.visibility = visible ? "visible" : "hidden";
      if (callback) callback();
    } else {
      el.style.visibility = visible ? "visible" : "hidden";
      if (callback) callback();
    }
  }

  /**
   * Selects an input field if the localStorage holds answers for the given page
   *
   */
  syncAnswer() {
    const inputFields = this.querySelectorAll(`.js-data`);
    this.store.answers = this.store.answers.filter(n => n);
    this.store.answers.forEach(({ answer }) => {
      const inputs = answer.split(";");
      inputs.forEach((value) => {
        inputFields.forEach((inputField) => {
          if (inputField?.type === "radio") {
            const radio = this.querySelector(`input[value="${value}"]`);
            if (radio) {
              radio.checked = true;
            }
          } else {
            inputFields.value = value;
          }
        });
      });
    });
  }

  /**
   * Updates localStorage with answer data + timestamps
   *
   * @param {string} answer - Answer data
   * @param {number} index  - Page index
   */
  handleInputChange(answer, index) {
    this.nextBtn.removeAttribute("disabled");
    this.collectData();

    // Change events are handled in the Findation component for page 3
    if (index == 1) {
      this.showCorrectOptions();
    }
  }

  // Used to check and update the correct options for page 2
  showCorrectOptions() {
    const storedQuiz = JSON.parse(localStorage.getItem("vieve-quiz"));
    const rangeAnswer = storedQuiz?.answers[0]?.answer;
    const answerWrappers = this.querySelectorAll(".single-answer-wrap");

    if (!rangeAnswer) {
      answerWrappers.forEach((wrap, index) => {
        if (index == 0) wrap.classList.add("active");
        else {
          wrap.classList.remove("active");
        }
      });
    } else {
      answerWrappers.forEach((wrap) => {
        if (wrap.dataset.id == rangeAnswer) {
          wrap.classList.add("active");
        } else {
          wrap.classList.remove("active");
        }
      });
    }
  }

  setProductSkeletonLoader() {
    let productGridInnerHTML = "";
    for (let i = 0; i < 6; i++) {
      productGridInnerHTML += /* html */ `
      <div class="qz-product-result-cell">
        <input type="hidden" name="id" value="">

        <div class="qz-product-result-top-wrap">
          <div class="qz-result-img-wrap loading">.</div>
          <p class="qz-result-title loading"> </p>
        </div>
      </div>
    `;
    }
    this.productGrid.innerHTML = productGridInnerHTML;

    let articlesInnerHTML = /* html */ `
      <div class="qz-page-article">
        <div class="qz-loader-bg"> </div>
        <div class="qz-article-title loading">TITLE</div>
      </div>
      <div class="qz-page-article">
        <div class="qz-loader-bg"> </div>
        <div class="qz-article-title loading">TITLE</div>
      </div>
    `;

    this.articles.innerHTML = articlesInnerHTML;
  }

  initializeProductRecommendations() {
    if (!this.recommendedProductsHTML && !this.articlesHTML) {
      this.setProductSkeletonLoader();
    } else {
      this.productGrid.innerHTML = this.recommendedProductsHTML;
      this.articles.innerHTML = this.articlesHTML;
      this.attachProductEvents();
    }
  }

  renderPrice(price){
    const newPrice = price.split(".")[0]
    const moneyFormat = this.dataset.moneyFormat
    return moneyFormat.replace('0.00', newPrice).replace('0,00', newPrice)
  }

  updateProductCard(event){
    const option = event.target.selectedOptions[0];
    const { price, image, availability } = option.dataset;
    const form =  event.target.closest("form")
    const buttonEl = form?.querySelector('.qz-product-result-btn');
    const imageEl = form?.querySelector('.qz-result-product-img');
    if(price && availability === "true") {
      buttonEl.innerText =  `Add to cart ${price ? ' - ' + this.renderPrice(price) : ""}`
    } else {
      buttonEl.innerText =  `Out of stock`;
    }
    if(imageEl && image){
      imageEl.setAttribute('src', image)
    }
  }


  attachProductEvents(){
    const forms =  this.querySelectorAll('.qz-product-form')
    forms.forEach(form => {
      form?.addEventListener('submit', (event) => {
        event.preventDefault()
        const formData = new FormData(event.target)
        this.quizAddToCart(formData)
      })
      form.querySelector('select')?.addEventListener('change', this.updateProductCard.bind(this))
      form.querySelector('.qz-result-product-wishlist')?.addEventListener('click', (event) => {
        event.currentTarget.classList.toggle('active');
        this.recommendedProductsHTML = this.querySelector('.qz-product-result-grid').innerHTML
        this.setLSRecommendedProductsHTML();
      })
    })
 
    this.querySelector('.qz-add-all-btn')?.addEventListener('click', () => {
      const items = this.querySelectorAll('[name^="items"]')
      const formData = new FormData()
      items.forEach(item => {
        if (!item.disabled) {
          formData.append(item.name, item.value); 
        }
      })
      this.quizAddToCart(formData);
    })
  }


  renderResults(response){
    if(!response?.data) {
      console.error("Results are not found!", response)
      return;
    }

    const { data } = response;
    const { Ingredient, TopTip } = data;

    let copyHTML = "";
    let productGridInnerHTML = "";

    const firstTitle = this.articles.dataset.firstTitle
    const secondTitle = this.articles.dataset.secondTitle
    const firstImage = this.articles.dataset.firstImage
    const secondImage = this.articles.dataset.secondImage
    
    const resultsCopy = [
      {
        title: firstTitle,
        description: Ingredient,
        image: firstImage,
      },
      {
        title: secondTitle,
        description: TopTip,
        image: secondImage,
      }
    ]; 

    resultsCopy.forEach(({ title, description, image }) => {
      copyHTML += /*html*/ `
        <div class="qz-page-article">
          <div class="qz-page-article">
            <picture>
              <source media="(max-width: 989px)" srcset=${image}>
              <img src=${image}>
            </picture>
          </div>
          <div class="qz-article-title">${title}</div>
          ${description ? `<div class="qz-article-content">${description}</div>` : ''}
        </div>
      `;
    });

    const outputKeys = Object.keys(data)
      .filter((key) => key.includes("Output"))
      .sort();

      let availableProducts = 0

    outputKeys.forEach((key, i) => {
      const variants = data[key];
      let selectedVariant = variants?.[0] || variants;
      let variantInput = '';
        if(variants.length > 1) {
          variantInput = `<select name='items[${i}][id]' class="qz-result-select">
                 ${variants.sort((a,b) => a.subtitle - b.subtitle).map((variant, idx) => {
                  const isSelected = variant.available && (this.quiz.results.selected_shade == variant.subtitle || idx === 0)
                  if(isSelected){
                    selectedVariant = variant
                  } 
                  return /*html*/`
                  <option 
                    value="${variant.variantid}" 
                    ${!variant.available ? " disabled" : isSelected ? " selected": ''} 
                    data-price="${variant.price}" 
                    data-image="${variant.image}" 
                    data-availability="${variant.available}"
                  >${variant.subtitle}</option>`
                 }).join('')}
                    </select>`;
         } else if(variants.variantlist){
          variantInput =   `<select name='items[${i}][id]' class="qz-result-select">
              ${variants.variantlist.map((variant, idx) => {
                const isSelected = (variants.variantid == variant.variantid)
                if(isSelected){
                  selectedVariant = variant
                } 
                variant.optiontitle = variant.title;
                if(variant.subtitle) {
                  variant.optiontitle = variant.subtitle;
                }
                return `
                <option 
                  value="${variant.variantid}" 
                  ${!variant.available ? " disabled" : isSelected ? " selected": ''} 
                  data-price="${variant.price}" 
                  data-image="${variant.image}" 
                  data-availability="${variant.available}"
                >${variant.optiontitle}</option>`
              }).join('')}
            </select>`;
        } else {
          variantInput = `<input type="hidden" name="items[${i}][id]" value="${selectedVariant.variantid}" ${!selectedVariant.available ? " disabled" : ""}>`;
        } 

        const { title, price, image, available } = selectedVariant

        if (available) {
          availableProducts++;
        }

      productGridInnerHTML += /*html*/ `
          <form class="qz-product-form qz-product-result-cell">
            <div class="qz-product-result-top-wrap">
              <div class="qz-result-img-wrap">
                ${
                  i === 0
                    ? /*html*/ `<span class="qz-result-match">Your match</span>`
                    : ""
                }
                
                <img class="qz-result-product-img" src="${image}" alt="${title}">
              </div>
              <p class="qz-result-title">${title}</p>
            </div>

            ${variantInput}

            <button type="submit" class="qz-product-result-btn" ${!available ? "disabled" : ""}>
               ${ available ? `${`Add to cart ${price ? ' - ' + this.renderPrice(price) : ""}`}` : "Out of Stock" }
            </button>
          </form>
        `;
    });

    const addAllButton = availableProducts > 1 ? `<button class="qz-add-all-btn">Add All ${availableProducts} to cart </button>` : '';
    this.productGrid.innerHTML = productGridInnerHTML + addAllButton;
    this.recommendedProductsHTML = productGridInnerHTML + addAllButton;
    this.articlesHTML = copyHTML;
    this.articles.innerHTML = this.articlesHTML;
    this.setLSRecommendedProductsHTML();

    try {
      const shade = this.quiz["answers"]["Skin Tone"]["answer"];
      const productCard = Array.from( this.querySelectorAll(".qz-results-product")).find((product) => product.dataset.productShade === shade);
      if (productCard) {
        this.quiz["results"]["vieve"] = productCard.dataset.productId;
      }
    } catch (error) {
      // console.log(error);
      return;
    }

    this.attachProductEvents()
  }

  async getProductRecommendations() {
    const answers = Object.values(this.quiz.answers).flatMap((answer) => {
      if (answer.answer) {
        return answer.answer;
      } else if (answer.answers) {
        return answer.answers;
      }
    });

    let answersAreTheSame = true;
    answers.forEach((answer) => {
      if (!this.recommendationsMemo.includes(answer)) {
        answersAreTheSame = false;
      }
    });

    this.recommendationsMemo.forEach((answer) => {
      if (!answers.includes(answer)) {
        answersAreTheSame = false;
      }
    });

    answersAreTheSame = false;
    if (answersAreTheSame) {
      return;
    } else {
      this.recommendationsMemo = answers;
      this.setLSRecommendationsMemo();
      this.setProductSkeletonLoader();
    }

    const body = { quiz: this.quiz, email: this.userEmail };

    try {
      const response = await fetch(
        "https://insights.sitenurture.com/app/client_specific/vieve-uk/api/getQuizResults.php?key=6581241872468",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        }
      );

      if (!response.ok) {
        throw new Error("Error: ", response.status);
      }

      const data = await response.json();
      this.renderResults(data);
      return data;
    } catch (error) {
      // console.log("Error: ", error);
    }
  }

  quizAddToCart(formData){
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = formData;
    const cartDrawer = document.querySelector('cart-drawer');

    if (cartDrawer) {
      formData.append('sections', cartDrawer.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
    }

    fetch(`${routes.cart_add_url}`, config)
      .then(response => response.json())
      .then(response => {
        console.log(response);
        if(response?.status){
          alert(response.message)
          throw new Error(`Quiz add to cart failed: ${response?.message || response?.statusText}`)
        }
        document.dispatchEvent(new CustomEvent(QUIZ_CLOSE_EVENT))
        cartDrawer?.renderContents(response);
        cartDrawer?.setActiveElement(document.activeElement);
      })
      .catch(err => {
        console.error(err)
      })
      .finally(() => {
        if (cartDrawer && cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');
      })
  }

  /**
   * Handles the subscription process when a user submits their email to join a mailing list or similar action, based on their quiz results.
   *
   * This asynchronous function first validates the email input against a regular expression to ensure it's in a valid format. If the email is valid, it constructs a request body containing the user's email and their quiz results, then sends a POST request to a specified API endpoint. Upon a successful response, it updates the UI to indicate success and disables the subscribe button. If the email is invalid, it updates the UI to indicate an error. It also attempts to find a product card that matches the user's selected shade and updates the quiz results with the product ID if found.
   *
   * @async

   * @returns {Promise<any>} Returns a promise that resolves with the response data from the API call if the email is valid and the request is successful; otherwise, it logs an error message.
   */
  async handleSubscribe() {
    const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;
    const inputValue = this.emailInput?.value ?? "";

    try {
      const shade = this.quiz["answers"]["Skin Tone"]["answer"];
      const productCard = Array.from(
        this.querySelectorAll(".qz-results-product")
      ).find((product) => product.dataset.productShade === shade);
      if (productCard) {
        this.quiz["results"]["vieve"] = productCard.dataset.productId;
      }

      if (!this.quiz["results"]["selected_shade"]) {
        this.quiz["results"]["selected_shade"] = shade;
      }

    } catch (error) {
      // console.log(error);
    }

    this.userEmail = emailRegex.test(inputValue) ? inputValue : ""

    const body = {
      email: this.userEmail,
      quiz: this.quiz,
    };

    try {
      const response = await fetch(
        "https://insights.sitenurture.com/app/client_specific/vieve-uk/api/quiztocustomer.php?key=6581241872468",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        }
      );

      if (!response.ok) {
        throw new Error("Error: ", response.status);
      }

      // console.log(body);

      if (this.emailError) this.emailError.classList.add("hidden");

      const data = await response.json();

      if (data?.customerid) {
        this.quiz["results"]["customerid"] = data.customerid;
        this.setQuizData()
      }

      return data;
    } catch (error) {
      // console.log("Error: ", error);
    }
  }
}

class CustomFindationBlock extends HTMLElement {
  constructor() {
    super();
    //
    this.productUrl = this.getURL();

    this.brandSelect = this.querySelector("#qz-findation-brands");
    this.productSelect = this.querySelector("#qz-findation-product");
    this.shadeSelect = this.querySelector("#qz-findation-shade");
  }

  async connectedCallback() {
    // console.log("PRODUCT URL -> ", this.productUrl);
    const storedQuiz = JSON.parse(localStorage.getItem("vieve-quiz")) ?? {};
    // if (storedQuiz.answers && storedQuiz.answers[2]) {
    //   this.brandInput.value = storedQuiz.answers[2].findationInputs.brand;
    //   this.productInput.value = storedQuiz.answers[2].findationInputs.product;
    //   this.shadeInput.value = storedQuiz.answers[2].findationInputs.shade;
    // }

    // Make API call and populate brand datalist
    this.brands = await this.getBrands();
    this.populateBrandsList(this.brands);

    this.embed = await this.getEmbed();

    this.brandSelect.addEventListener("change", async () => {
      // Reset the product Select and datalist when a new brand is selected.
      this.productSelect.innerHTML = /* html */`<option value="">Select Product</option>`;
      this.productSelect.value = "";

      // Reset the shade Select and datalist when a new brand is selected.
      this.shadeSelect.innerHTML = /* html */`<option value="">Select Shade</option>`;
      this.shadeSelect.value = "";

      // Get the new products and populate the datalist when a new brand is selected.
      this.products = await this.getProducts();
      this.populateProductsList(this.products);
    });

    this.productSelect.addEventListener("change", async () => {
      // Reset the shade Select and datalist when a new brand is selected.
      this.shadeSelect.innerHTML = /* html */`<option value="">Select Shade</option>`;
      this.shadeSelect.value = "";

      this.shades = await this.getShades();
      this.populateShadesList(this.shades);
    });

    this.shadeSelect.addEventListener("change", async () => {
      const productTitle = document
        .querySelector(".product__title h1")
        ?.innerText?.toLowerCase();
      const productShade = document
        .querySelector(".js-selected-color")
        ?.innerText?.toLowerCase();

      const pageEvents =
        JSON.parse(localStorage.getItem("qI-page-events")) ?? [];

      if (this.shadeSelect.value) {
        this.match = await this.searchForMatch();

        // Add response to page events analytics
        pageEvents.push({
          name: "quiz-action",
          data: {
            action: "Findation",
            requestBody: {
              brand: this.brandSelect.value,
              product: this.productSelect.value,
              shade: this.shadeSelect.value,
            },
            response: this.match,
          },
          timestamp: new Date().toISOString(),
        });
        localStorage.setItem("qI-page-events", JSON.stringify(pageEvents));
      }
    });
    
    document.addEventListener(FINDATION_ADD_MORE_SHADES, () => {
      this.resetInputs();
    });
  }

  async resetInputs() {
    // Reset the product Select and datalist when a new brand is selected.
    this.brandSelect.innerHTML = /* html */`<option value="">Select Brand</option>`;
    this.brandSelect.value = "";

    // Reset the product Select and datalist when a new brand is selected.
    this.productSelect.innerHTML = /* html */`<option value="">Select Product</option>`;
    this.productSelect.value = "";

    // Reset the shade Select and datalist when a new brand is selected.
    this.shadeSelect.innerHTML = /* html */`<option value="">Select Shade</option>`;
    this.shadeSelect.value = "";

    this.brands = await this.getBrands();
    this.populateBrandsList(this.brands);
  }

  /**
   * Populates the first Select for "brands" (coming from API call)
   */
  populateBrandsList(brands) {
    brands.forEach((brand) => {
      const option = document.createElement("option");
      option.value = brand.name;
      option.innerText = brand.name;
      this.brandSelect.appendChild(option);
    });
  }

  /**
   * Populates the second input for "products" (coming from API call)
   */
  populateProductsList(products = []) {
    this.productSelect.removeAttribute('disabled');
    products.forEach((product) => {
      const option = document.createElement("option");
      option.value = product.name;
      option.innerText = product.name;
      this.productSelect.appendChild(option);
    });
  }

  /**
   * Populates the third input for "shades" (coming from API call)
   */
  populateShadesList(shades = []) {
    this.shadeSelect.removeAttribute('disabled');
    shades.forEach((shade) => {
      const option = document.createElement("option");
      option.value = shade.name;
      option.innerText = shade.name;
      this.shadeSelect.appendChild(option);
    });
  }

  getURL() {
    if (window.location.pathname.includes("/products")) {
      // console.log("PDP URL");
      // console.log("PATHNAME");
      // console.log(window.location.pathname);
      return "https://www.vieve.co.uk/modern-radiance-concealer-light1"
    } else {
      return "https://www.vieve.co.uk/modern-radiance-concealer-light1"; // Default value
    }
  }

  /**
   * @see https://findation.com/merchants/api_documentation/1.0/brands.html
   */
  async getBrands() {
    try {
      const response = await fetch(
        `https://www.findation.com/api/brands?api_key=${FINDATION_API_KEY}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error("Error: ", response.status);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      // console.log("Error getting brands from Findation: ", error);
    }
  }

  /**
   * @see https://findation.com/merchants/api_documentation/1.0/products.html
   */
  async getProducts() {
    const selectedBrand = this.brandSelect.value;
    const brandEntry = this.brands.find((brand) => brand.name == selectedBrand);

    if (brandEntry) {
      try {
        const response = await fetch(
          `https://www.findation.com/api/products?brand_id=${brandEntry.id}&api_key=${FINDATION_API_KEY}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          throw new Error("Error: ", response.status);
        }

        const data = await response.json();
        return data;
      } catch (error) {
        // console.log("Error getting products from Findation: ", error);
      }
    }
  }

  /**
   * @see https://findation.com/merchants/api_documentation/1.0/shades/index.html
   */
  async getShades() {
    const selectedProduct = this.productSelect.value;
    const productEntry = this.products.find(
      (product) => product.name == selectedProduct
    );

    if (productEntry) {
      try {
        const response = await fetch(
          `https://www.findation.com/api/shades?product_id=${productEntry.id}&api_key=${FINDATION_API_KEY}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          throw new Error("Error: ", response.status);
        }

        const data = await response.json();
        return data;
      } catch (error) {
        // console.log("Error getting products from Findation: ", error);
      }
    }
  }

  /**
   * @see https://findation.com/merchants/api_documentation/1.0/embed.html
   */
  async getEmbed() {
    const postData = {
      product_url: this.productUrl,
      api_key: FINDATION_API_KEY,
    };

    try {
      const response = await fetch(`https://www.findation.com/api/embed`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(postData),
      });

      if (!response.ok) {
        throw new Error("Error: ", response.status);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      // console.log("Error getting embed from Findation: ", error);
    }
  }

  /**
   * Findation - POST /api/search
   * @see https://findation.com/merchants/api_documentation/1.0/search.html
   */
  async searchForMatch() {
    const selectedShade = this.shadeSelect.value;
    // console.log('selectedShade: ', selectedShade);
    const shadeEntry = this.shades.find((shade) => {
      return shade.name == selectedShade;
    });

    // console.log('shades: ', this.shades,shadeEntry);

    /*
    const postData = {
      lookup_reference_id: "c-b",
      api_key: FINDATION_API_KEY,
      shade_ids: [shadeEntry?.id],
    };
    */

    const postData = {
      embed_id: "32567",
      api_key: FINDATION_API_KEY,
      shade_ids: [shadeEntry?.id],
      product_url:"https://www.vievebeauty.com/products/skin-nova-complexion-balm-deep-400"
    };

    if (shadeEntry) {
      try {
        const response = await fetch(
          `https://www.findation.com/api/search`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(postData),
          }
        );

        if (!response.ok) {
          throw new Error("Error: ", response.status);
        }

        const data = await response.json();
        const recommendations = data;

        if (recommendations) {
        // console.log('recommendations: ', recommendations);
          const id = recommendations.id;
          const recommended_shade = recommendations.recommended_shade;
          const product_name = recommendations.product_name;

          const event = new CustomEvent(FINDATION_MATCH, {
            detail: {
              title: product_name,
              shade: recommended_shade,
              id: id,
            },
          });
          document.dispatchEvent(event);
        }

        return data;
      } catch (error) {
        // console.log("Error getting brands from Findation: ", error);
      }
    }
  }
}

if (!customElements.get("quiz-popup")) {
  customElements.define("quiz-popup", QuizPopup);
}

if (!customElements.get("custom-findation-block")) {
  customElements.define("custom-findation-block", CustomFindationBlock);
}

const keys = {}

window.addEventListener('keydown', (ev) => {
  keys[ev.key] = true
})

window.addEventListener('keyup', (ev) => {
  if (keys['q'] && keys['f'] ) {
    const quizData = localStorage.getItem('vieve-shade-quiz');
    if(quizData) {
      navigator.clipboard.writeText(quizData);
      alert('Please send the contents of your clipboard to QF');
    }
  }
  keys[ev.key] = false
})